import {baseApiPostFetcher} from "@/lib/api/baseInstances/bryaPublicApiFetcher";
import {z} from "zod";
import {quoteProductTypesSchema} from "@/lib/formValidators/quoteWizard/QuoteProductTypes";
import {QuickQuoteSchema} from "@/lib/formValidators/quoteWizard/quickQuoteForm";

const quoteProductsPostApiPath: string = process.env.NEXT_PUBLIC_BRYA_API_QUOTES_PRODUCTS_URL? process.env.NEXT_PUBLIC_BRYA_API_QUOTES_PRODUCTS_URL : '';
const quickQuotePostApiPath: string = process.env.NEXT_PUBLIC_BRYA_API_QUICK_QUOTE_CREATE_PATH? process.env.NEXT_PUBLIC_BRYA_API_QUICK_QUOTE_CREATE_PATH : '';

type QuoteProductType = z.infer<typeof quoteProductTypesSchema>;

export async function updateQuoteProductCategories(apiPayload: QuoteProductType) : Promise<any>  {

    const response = await baseApiPostFetcher(quoteProductsPostApiPath,apiPayload)
    console.log("Mutating the Session SWR to revalidate",quoteProductsPostApiPath)

}

type CreateQuickQuoteType = z.infer<typeof QuickQuoteSchema>;
export async function createQuickQuote(apiPayload: CreateQuickQuoteType) : Promise<any>  {

    console.log("Ready to Post Create Quick Quote",quickQuotePostApiPath );

    return await baseApiPostFetcher(quickQuotePostApiPath, apiPayload);

}